// client/src/components/influencer/project/modals/ProjectApplyConfirmModal.js
import React from 'react';

export default function ProjectApplyConfirmModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="influencer-project-modal" style={{ zIndex: 10002 }}>
      <div className="project-apply-confirm">
        {/* 성공 아이콘 */}
        <div className="project-apply-confirm__icon-wrap">
          <div className="project-apply-confirm__icon">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
              <circle cx="40" cy="40" r="38" fill="#10b981" fillOpacity="0.1" />
              <circle cx="40" cy="40" r="32" fill="#10b981" />
              <path 
                d="M25 40L35 50L55 30" 
                stroke="white" 
                strokeWidth="4" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* 메인 메시지 */}
        <h2 className="project-apply-confirm__title">
          지원이 완료되었습니다! 🎉 (Application submitted!)
        </h2>

        {/* 설명 */}
        <div className="project-apply-confirm__description">
          <p className="project-apply-confirm__text">
            광고주가 인플루언서님을 선정하면<br />
            문자로 알림을 보내드립니다. (You will be notified via SMS if the advertiser selects you.)
          </p>
        </div>

        {/* 안내 사항 */}
        <div className="project-apply-confirm__info-box">
          <div className="project-apply-confirm__info-item">
            <span className="project-apply-confirm__info-icon">📱</span>
            <span className="project-apply-confirm__info-text">
              선정 시 등록된 번호로 문자 발송 (SMS sent upon selection)
            </span>
          </div>
          <div className="project-apply-confirm__info-item">
            <span className="project-apply-confirm__info-icon">⏰</span>
            <span className="project-apply-confirm__info-text">
              선정 시, 36시간 이내 계약 수락 필요 (Accept the contract within 36 hours of selection)
            </span>
          </div>
          <div className="project-apply-confirm__info-item">
            <span className="project-apply-confirm__info-icon">💼</span>
            <span className="project-apply-confirm__info-text">
              마이비즈에서 지원 현황 확인 가능 (Track your applications in My Biz)
            </span>
          </div>
        </div>

        {/* 확인 버튼 */}
        <button
          onClick={onClose}
          className="project-apply-confirm__btn"
        >
          확인 (OK)
        </button>
      </div>
    </div>
  );
}